import clsx from 'clsx';

interface Props {
    customStyle: 'info';
    children: React.ReactNode;
}

const Alert = ({ customStyle, children }: Props): JSX.Element => {
    return <div className={clsx(customStyle === 'info' && 'alert--info')}>{children}</div>;
};

export default Alert;
